import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import { useCopyToClipboard } from "react-use";
import { Icon } from "~/features/ui/icon";
import Checkmark from "~/public/icons/checkmark.svg";
import Copy from "~/public/icons/copy.svg";
type Props = {
  text: string;
};
export function CodeBlock(props: Props) {
  const {
    text
  } = props;
  const [copiedState, copyToClipboard] = useCopyToClipboard();
  const [showCopiedStatus, setShowCopiedStatus] = React.useState(false);
  React.useEffect(() => {
    if (copiedState.value) {
      setShowCopiedStatus(true);
      const timer = setTimeout(() => {
        setShowCopiedStatus(false);
        copiedState.value = undefined;
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [copiedState]);
  return <_StyledDiv className="group">
      <_StyledPre>
        <_StyledCode>{text}</_StyledCode>
      </_StyledPre>

      <_StyledButton onClick={() => copyToClipboard(text || "")} $_css={[{
      "position": "absolute",
      "right": "0.8rem",
      "top": "0.6rem",
      "display": "inline-flex",
      "alignItems": "center",
      "justifyContent": "center",
      "padding": "0.4rem"
    }, {
      "userSelect": "none",
      "borderRadius": "4px",
      "borderWidth": "1px",
      "borderStyle": "solid",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(208 208 218 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))"
    }, {
      "opacity": "0",
      "transitionProperty": "opacity",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out",
      ".group:hover &": {
        "opacity": "1"
      }
    }]}>
        <Icon icon={showCopiedStatus ? Checkmark : Copy} />
        <_StyledSpan>Copy to clipboard</_StyledSpan>
      </_StyledButton>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-tlhjpt-0"
})({
  "position": "relative",
  "overflowX": "auto",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))"
});
var _StyledPre = _styled2("pre").withConfig({
  componentId: "sc-sf-tlhjpt-1"
})({
  "margin": "0",
  "display": "block",
  "overflow": "auto",
  "whiteSpace": "pre",
  "padding": "1.2rem"
});
var _StyledCode = _styled3("code").withConfig({
  componentId: "sc-sf-tlhjpt-2"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledButton = _styled4("button").withConfig({
  componentId: "sc-sf-tlhjpt-3"
})`${p => p.$_css}`;
var _StyledSpan = /*#__PURE__*/_styled5("span").withConfig({
  displayName: "code-block___StyledSpan",
  componentId: "sc-18e1r8y-0"
})({
  "position": "absolute",
  "width": "1px",
  "height": "1px",
  "padding": "0",
  "margin": "-1px",
  "overflow": "hidden",
  "clip": "rect(0, 0, 0, 0)",
  "whiteSpace": "nowrap",
  "borderWidth": "0"
});